import { cx } from '@emotion/css';
import { Skeleton } from '@sortlist-frontend/design-system';
import { useMediaQuery } from '@sortlist-frontend/design-system/legacy';

export const FormSkeleton = () => {
  const { media_legacy } = useMediaQuery();

  return (
    <div
      data-testid="form-skeleton"
      className={cx(media_legacy.gtXs ? 'bg-neutral-50 border border-secondary-300 rounded-lg' : 'bg-secondary-50')}>
      <header className="layout-column layout-align-start-start pt-12 px-8 pb-8">
        <Skeleton className="h-8 w-[60%] rounded-sm" />
        <Skeleton className="h-4 w-[35%] rounded-sm mt-4" />
      </header>
      {new Array(3).fill(null).map((key, index) => (
        <section className="p-4" key={`skeleton-section-${index}`}>
          <Skeleton className="h-5 w-40 rounded-sm mx-4" />
          {new Array(2).fill(null).map((key, index) => (
            <div className="layout-row layout-align-start-start" key={`skeleton-div-${index}`}>
              {new Array(2).fill(null).map((key, index) => (
                <div className="flex-1 p-4 layout-column layout-align-start-start" key={`skeleton-subdiv-${index}`}>
                  <Skeleton className="h-4 w-30 rounded-sm mt-2" />
                  <Skeleton className="h-[38px] w-full rounded-sm mt-2" />
                </div>
              ))}
            </div>
          ))}
        </section>
      ))}
      <footer className="px-8 pb-8 layout-row layout-align-end-center">
        <Skeleton className="h-11 w-30 rounded-sm" />
      </footer>
    </div>
  );
};
